import styles from "./PortalCalendar.module.scss";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { ItemsList } from "../../../common/components/itemsList/ItemsList";
import { EventItem } from "./components/EventItem";
import { usePortalCalendar } from "./hooks/usePortalCalendar";
import { EventDetails } from "./components/EventDetails";
import { classNames } from "primereact/utils";
import { AppDialog } from "../../../common/components/AppDialog/AppDialog";
import { UserSelectionDialog } from "./components/UserSelectionDialog";
import { EventNameFilterTabs } from "./components/EventNameFilterTabs";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { PrepaymentDialog } from "../../../common/components/PrepaymentDialog/PrepaymentDialog";
import { PreReservationFormDialog } from "../../../common/preReservationForms/PreReservationFormDialog";
import {
  buildClientFormContext,
  buildEventFormContext,
} from "../../../common/preReservationForms/clientFormContext";
import { useAppContext } from "../../../AppContext";

// Comes from the common calendar router
export const PortalCalendar = () => {
  const { selectedStudio, currentUser } = useAppContext();
  const {
    isLoading,
    eventsForCurrentDate,
    selectedValue,
    isDesktopOrTablet,
    currentlySelectedEvent,
    showEventId,
    showUserSelectionDialog,
    responsibleForUsersData,
    usersWithoutReservation,
    visibleUntil,
    setShowUserSelectionDialog,
    setShowEventId,
    onTryEventSignUp,
    onEventSignUp,
    tileContent,
    handleDateChange,
    distinctEventNames,
    selectedEventName,
    setSelectedEventName,
    prepaymentDialogContext,
    prepaymentDialogEvent,
    onPrepaymentDialogConfirm,
    onPrepaymentDialogCancel,
    preReservationForm,
    formDialogEvent,
    showFormDialog,
    onFormDialogAgree,
    onFormDialogDisagree,
  } = usePortalCalendar();

  return (
    <div className={styles.root}>
      <Calendar
        key={selectedEventName ?? "all"}
        className={styles.calendar}
        tileClassName={styles.calendar_tile}
        onChange={handleDateChange}
        value={selectedValue}
        tileContent={tileContent}
        locale="BG"
        minDate={new Date()}
        maxDate={visibleUntil && new Date(visibleUntil)}
      />

      <ItemsList
        className={styles.items}
        isLoading={isLoading}
        numberOfItems={10}
        enableSearch
        searchClassName={styles.items_search}
        fullHeight
        fullWidth
        title={
          <>
            <div className={styles.items_title}>Предстоящи</div>
            <EventNameFilterTabs
              eventNames={distinctEventNames}
              selectedName={selectedEventName}
              onSelect={setSelectedEventName}
            />
          </>
        }
        noItemsText="Няма открити събития за тази дата."
        itemTemplate={(item, index, actionButtons) => {
          return (
            <EventItem
              item={item}
              isLoading={isLoading}
              onEventClick={setShowEventId}
              key={item?.id ?? index}
              actionButtons={actionButtons}
            />
          );
        }}
        items={eventsForCurrentDate ?? []}
      />

      <AppDialog
        header={"Детайли за класа"}
        visible={!!showEventId}
        onHide={() => setShowEventId(undefined)}
        style={{ width: isDesktopOrTablet ? "650px" : "90vw" }}
        headerClassName={classNames(
          styles.calendar_dialog,
          styles.calendar_dialog_header
        )}
        contentClassName={classNames(
          styles.calendar_dialog,
          styles.calendar_dialog_content
        )}
      >
        <EventDetails
          currentEvent={currentlySelectedEvent}
          responsibleForUsersIds={responsibleForUsersData?.map((x) => x.id)}
          onEventSignUp={onTryEventSignUp}
        />
      </AppDialog>

      <AppDialog
        visible={showUserSelectionDialog}
        header={"Избиране на потребител"}
        onHide={() => setShowUserSelectionDialog(false)}
        style={{ width: isDesktopOrTablet ? "450px" : "90vw" }}
      >
        <UserSelectionDialog
          users={usersWithoutReservation}
          onTryReserve={(selectedUserId: number) =>
            onEventSignUp(showEventId, selectedUserId)
          }
        />
      </AppDialog>

      <PrepaymentDialog
        visible={!!prepaymentDialogContext}
        eligiblePlansEndpoint={
          prepaymentDialogContext && prepaymentDialogEvent
            ? `${endpointsMetadata.portalCalendar.eligiblePlans}?eventId=${prepaymentDialogEvent.id}&userId=${prepaymentDialogContext.userId}`
            : undefined
        }
        eligiblePlansQueryKey={[
          endpointsMetadata.portalCalendar.eligiblePlans,
          prepaymentDialogEvent?.id,
          prepaymentDialogContext?.userId,
        ]}
        price={prepaymentDialogEvent?.price ?? 0}
        prepaymentProvider={prepaymentDialogEvent?.prepaymentProvider}
        isDesktopOrTablet={isDesktopOrTablet}
        isPrepaid={!!prepaymentDialogEvent?.requirePrepayment}
        allowMultisport={!!prepaymentDialogEvent?.isMultisportAvailable}
        onConfirm={onPrepaymentDialogConfirm}
        onCancel={onPrepaymentDialogCancel}
      />

      {preReservationForm?.id && (
        <PreReservationFormDialog
          visible={showFormDialog}
          formName={preReservationForm.name}
          templateText={preReservationForm.templateText}
          contextValues={buildClientFormContext(
            selectedStudio,
            currentUser,
            buildEventFormContext(formDialogEvent),
          )}
          onAgree={onFormDialogAgree}
          onDisagree={onFormDialogDisagree}
        />
      )}
    </div>
  );
};
